//import firebase from "firebase/app";
//import firebaseMessagingSW from "./firebase-messaging-sw";
import firebase from "firebase/compat/app";
import "firebase/compat/messaging";
import { protectedPost } from "./../restUtil";
import { logInfo } from "./../logging";

const SESSION_INVITE_TYPE = "session_invite";
const OTHER_CONNECTED_TYPE = "other_user_connected";

function requestNotificationsPermissions(onSuccess, onError) {
  Notification.requestPermission()
    .then(function () {
      // Notification permission granted.
      getToken(onSuccess);
    })
    .catch(function (error) {
      logInfo("got error while asking permissions for firebase notifications", {
        from: "requestNotificationsPermissions",
        error: error,
      });
      onError && onError("Unable to get permission to notify.");
    });
}

export function getToken(onSuccess, onError) {
  firebase
    .messaging()
    .getToken()
    .then(function (currentToken) {
      if (currentToken) {
        // Saving the Device Token to the datastore.
        //firebase.database().ref("/fcmTokens").child(currentToken)
        //    .set(firebase.auth().currentUser.uid);
        onSuccess && onSuccess(currentToken);
      } else {
        // Need to request permissions to show notifications.
        requestNotificationsPermissions(onSuccess, onError);
      }
    })
    .catch(function (error) {
      logInfo("got error while requesting firebase notifications token", {
        from: "getToken",
        error: error,
      });
      onError && onError("Unable to get messaging token.");
    });
}

export function saveFirebaseNotificationToken(onSuccess, onError) {
  if (window.Cypress) {
    // No firebase notifications from CI.
    onSuccess && onSuccess();
    return;
  }
  //initializeFirebase();
  try {
    if (firebase === null || firebase === undefined) {
      return onError && onError("firebase is not found");
    } else if (firebase.messaging() === null || firebase.messaging() === undefined) {
      return onError && onError("firebase.messaging() is not found");
    }
  } catch (e) {
    logInfo("got error while requesting firebase or messaging object", {
      from: "saveFirebaseNotificationToken",
      error: e,
    });
    return onError && onError(e);
  }
  addNotificationHandler();

  return getToken(token => {
    return sendTokenToServer(token, onSuccess, onError);
  }, onError);
}

function sendTokenToServer(token, onSuccess, onError) {
  return protectedPost(
    "/push/token",
    {
      token: token,
    },
    onSuccess,
    errors => {
      return onError && onError(errors);
    }
  );
}

function addNotificationHandler() {
  if (firebase.messaging) {
    const messaging = firebase.messaging();
    messaging.onMessage(function (payload) {
      // eslint-disable-next-line
      console.log("Message received. ", payload);

      // We have this implementation in 2 places: here and in firebase-messaging-sw.js.
      // TODO Rework to use code from 1 place.
      const notificationTitle = "Talaera Session";
      var body = null;
      var data = JSON.parse(payload.data.data);
      if (
        payload.data.type === SESSION_INVITE_TYPE ||
        payload.data.type === OTHER_CONNECTED_TYPE
      ) {
        var validOther = data.other_user && data.other_user.first_name;
        if (payload.data.type === SESSION_INVITE_TYPE) {
          if (validOther) {
            body = "Your Talaera lesson with " + data.other_user.first_name;
          } else {
            body = "Your Talaera lesson";
          }

          if (
            data.lesson &&
            data.lesson.scheduled &&
            new Date().getTime() >= new Date(data.lesson.scheduled).getTime()
          ) {
            body += " has started.";
          } else {
            body += " starts in five minutes.";
          }
        } else if (payload.data.type === OTHER_CONNECTED_TYPE) {
          var otherName = validOther ? data.other_user.first_name : "The other user";
          body = otherName + " has just joined your Talaera session.";
        }
      }

      if (body !== null) {
        const notificationOptions = {
          body: body,
          icon: "/favicon.png",
        };

        if (!("Notification" in window)) {
          // eslint-disable-next-line
          console.log("This browser does not support system notifications");
        } else if (Notification.permission === "granted") {
          // If notification permissions have already been granted, let's create a notification
          var notification = new Notification(notificationTitle, notificationOptions);
          notification.onclick = function (event) {
            event.preventDefault(); // prevent the browser from focusing the Notification's tab
            window.open(payload.notification.click_action, "_blank");
            notification.close();
          };
        }
      }
    });
  }
}

export const onMessageListener = () => {
  if (navigator.serviceWorker && firebase.messaging) {
    const messaging = firebase.messaging();
    return new Promise(resolve => {
      messaging.onMessage(payload => {
        if (
          !(
            payload.data.type === SESSION_INVITE_TYPE ||
            payload.data.type === OTHER_CONNECTED_TYPE
          )
        ) {
          resolve(payload);
        }
      });
    });
  }
};
